import { axiosChartInstance } from "config";
import { useAxiosMutation } from "hooks";
import { useQueryClient } from "react-query";

type DeleteAuditCommentsReplyProps = {
  encounterId: string;
  chartCode: string;
  sectionCode: string;
  subsectionCode?: string;
};

function useDeleteAuditCommentsReply({
  encounterId,
  chartCode,
  sectionCode,
  subsectionCode,
}: DeleteAuditCommentsReplyProps) {
  const queryClient = useQueryClient();

  return useAxiosMutation(
    [
      "deleteAuditCommentsReply",
      { encounterId, chartCode, sectionCode, subsectionCode },
    ],
    (replyId: string) => {
      const endpoint = subsectionCode
        ? `/v1/audits/subsection/comments/reply/${replyId}`
        : `/v1/audits/section/comments/reply/${replyId}`;
      return axiosChartInstance.delete(endpoint);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          "AuditComments",
          { encounterId, chartCode, sectionCode, subsectionCode },
        ]);
        queryClient.invalidateQueries([
          "AuditCommentsReplySubsectionIndicator",
          { encounterId, chartCode, sectionCode, subsectionCode },
        ]);
      },
    }
  );
}

type DeleteAuditCommentsSharedReplyProps = {
  encounterId: string;
  sectionCode: string;
  subsectionCode?: string;
};

function useDeleteAuditCommentsSharedReply({
  encounterId,
  sectionCode,
  subsectionCode,
}: DeleteAuditCommentsSharedReplyProps) {
  const queryClient = useQueryClient();

  return useAxiosMutation(
    [
      "deleteSharedAuditCommentsReply",
      { encounterId, sectionCode, subsectionCode },
    ],
    (replyId: string) =>
      axiosChartInstance.delete(
        `/v1/audits/subsection/comments/reply/${replyId}`
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          "AuditCommentsShared",
          { encounterId, sectionCode, subsectionCode },
        ]);
      },
    }
  );
}

export { useDeleteAuditCommentsReply, useDeleteAuditCommentsSharedReply };
